import { render, staticRenderFns } from "./precision.vue?vue&type=template&id=546a057c&scoped=true"
import script from "./precision.vue?vue&type=script&lang=js"
export * from "./precision.vue?vue&type=script&lang=js"
import style0 from "./precision.vue?vue&type=style&index=0&id=546a057c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a057c",
  null
  
)

export default component.exports